const required = (error: string) => (value: any) => (value ? undefined : error);

const emailRegex = /(.+)@(.+){2,}\.(.+){2,}/;
const email = (error: string) => (value: any) => {
  if (!value) return ''; // compose with required if desired
  if (emailRegex.test(value)) return '';
  return error;
};

const phoneRegex = /^\D*\d{3}\D*\d{3}\D*\d{4}\D*$/;
const DEFAULT_PHONE_ERROR = 'Please enter complete phone number ((999) 999-9999)';
const phone = (error?: string) => (value: any) => {
  if (!value) return ''; // compose with required if desired
  if (phoneRegex.test(value)) return '';
  return error || DEFAULT_PHONE_ERROR;
};

const regex = (regex: RegExp, error: string) => (value: any) => {
  if (!value) return ''; // compose with required if desired
  if (regex.test(value)) return '';
  return error;
};

const compose = (...validators: Array<(value: any) => any>) => (value: any) => {
  let result;
  validators.every(
    (fn) => {
      if (!fn) return null;
      result = fn(value);
      return !result;
    },
  );
  return result;
};

export {
  compose,
  required,
  email,
  regex,
  phone,
};
